module.exports = __webpack_public_path__ + "img/login-logo.aea65cc2.png";